const addUserCard = (card) => {
  return { type: "ADD_USER_CARD", payload: card };
};

export default addUserCard;
